import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PublicationComponent } from './publication/publication.component';
import { CreditComponent } from './credit/credit.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { ChooseoptionsComponent } from './chooseoptions/chooseoptions.component';
import { AreaselectionComponent } from './areaselection/areaselection.component';
import { LocationComponent } from './location/location.component';
import { TermsandconditionComponent } from './termsandcondition/termsandcondition.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { OutputsComponent } from './outputs/outputs.component';
import { AuthGuard } from './auth.guard';
import { PlantlistComponent } from './plantlist/plantlist.component';
import { StatsComponent } from './stats/stats.component';
import { DemoComponent } from './demo/demo.component';
import { AppinfoComponent } from './appinfo/appinfo.component';
import { AppinputsComponent } from './appinputs/appinputs.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'publication', component: PublicationComponent },
  { path: 'credits', component: CreditComponent },
  { path: 'feedback', component: FeedbackComponent },
  { path: 'otp', component: OtpVerifyComponent },
  { path: 'chooseoption', component: ChooseoptionsComponent, canActivate: [AuthGuard] },
  { path: 'areaselection', component: AreaselectionComponent, canActivate: [AuthGuard] },
  { path: 'location', component: LocationComponent, canActivate: [AuthGuard] },
  { path: 'forgotpassword', component: ForgotpasswordComponent },
  { path: 'terms', component: TermsandconditionComponent },
  { path: 'outputs', component: OutputsComponent, canActivate: [AuthGuard] },
  { path: 'plants', component: PlantlistComponent, canActivate: [AuthGuard] },
  { path: 'stats', component: StatsComponent, canActivate: [AuthGuard] },
  { path: 'demo', component: DemoComponent, canActivate: [AuthGuard] },
  { path: 'appinfo', component: AppinfoComponent, canActivate: [AuthGuard] },
  { path: 'appinputs', component: AppinputsComponent, canActivate: [AuthGuard] },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 0], // [x, y]
    useHash: true,
    onSameUrlNavigation: 'reload',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
